/* eslint-disable @typescript-eslint/no-empty-function */
import ButtonVuzoom from "common/components/Button/Button"
import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import Modal from "common/components/Modal/Modal"
import CuentasContablesService from "common/services/CuentasContablesService"
import notification from "common/utils/notification"
import { userSelector } from "features/User/redux/slices/userSlice"
import { Formik } from "formik"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
// eslint-disable-next-line import/no-cycle
import { DropdownChangeParams } from "primereact/dropdown"
import { DropdownCuentasContablesConModal } from "../DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"

const ModalCrearCuentaContable = ({
  visible,
  onHide,
  listaDeCuentasBase,
  appNewCuenta,
  initialData,
  nameOnCreate,
  cuentaPorDefecto,
  editing = false,
  refreshFetchData = () => {},
  alternativeAction = () => {},
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    empresaActiva: {
      configuracion: { digitosCuentasContables },
    },
  } = useSelector(userSelector)

  const onSubmit = useCallback(
    async (values: $TSMigrationFixMe) => {
      if (!editing) {
        try {
          const { data: newCuentaContableID } =
            await CuentasContablesService.createCuentaContable({
              cuentaContableId: values.tipoCuenta,
              nombre: values.nombre,
              numero: values.numero,
            })
          alternativeAction()
          refreshFetchData()
          appNewCuenta({ value: newCuentaContableID })
          notification.success({
            body: `${t("cuadroCuentas.msg.createCCExit")}`,
          })

          onHide()
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err)
        }
      } else {
        try {
          await CuentasContablesService.editCuentaContableEmpresa(
            initialData.data.id,
            {
              ...values,
              cuentaContableId: Number(values.tipoCuenta),
            }
          )
          alternativeAction()
          refreshFetchData()
          notification.success({
            body: `${t("cuadroCuentas.msg.editExit")}`,
          })
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(`Èrror:${e}`)
        }

        onHide()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appNewCuenta, dispatch, onHide]
  )

  return (
    <Modal
      header={
        editing
          ? t("cuadroCuentas.modal.editTitle")
          : t("cuadroCuentas.modal.newTitle")
      }
      maskClassName='!tw-z-40'
      visible={visible}
      onHide={onHide}
      draggable
    >
      {visible && (
        <Formik
          initialValues={{
            tipoCuenta: editing
              ? initialData?.tipoCuenta
              : cuentaPorDefecto?.id,
            nombre: !editing
              ? Number.isNaN(Number(initialData))
                ? nameOnCreate ?? initialData
                : nameOnCreate
              : initialData.nombre,
            numero: !editing
              ? Number.isNaN(Number(initialData))
                ? null
                : Number(initialData)
              : initialData.numero,
          }}
          validationSchema={Yup.object().shape({
            tipoCuenta: Yup.number()
              .nullable()
              // @ts-expect-error TS(2345): Argument of type 'DefaultTFuncReturn' is not assig...
              .required(t("formik.msg.emptyCamp")),
            // @ts-expect-error TS(2345): Argument of type 'DefaultTFuncReturn' is not assig...
            nombre: Yup.string().nullable().required(t("formik.msg.emptyCamp")),
            numero: Yup.number()
              .nullable()
              // @ts-expect-error TS(2345): Argument of type 'DefaultTFuncReturn' is not assig...
              .required(t("formik.msg.emptyCamp"))
              .test(
                "len",
                `${t("formik.msg.minCaracterOne")}${digitosCuentasContables}${t(
                  "formik.msg.minCaracterTwo"
                )}`,
                (val) => val?.toString().length === digitosCuentasContables
              ),
          })}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, setFieldValue, values, errors, touched }) => {
            return (
              <form
                onSubmit={handleSubmit}
                className='text-left p-fluid p-formgrid'
              >
                <div className='p-field'>
                  <label htmlFor='tipoCuenta'>
                    {t("cuadroCuentas.modal.typeLabel")}
                  </label>
                  <DropdownCuentasContablesConModal
                    cuentasContablesOptions={listaDeCuentasBase}
                    dropdownValue={values.tipoCuenta}
                    onChange={(newTipoDeCuenta: DropdownChangeParams) =>
                      setFieldValue("tipoCuenta", newTipoDeCuenta.value)
                    }
                  />
                  {errors.tipoCuenta && touched.tipoCuenta && (
                    <small className='p-error p-d-block'>
                      {errors.tipoCuenta as string}
                    </small>
                  )}
                </div>
                <div className='p-field'>
                  <label htmlFor='nombre'>
                    {t("cuadroCuentas.modal.nameLabel")}
                  </label>

                  <FormikInputText
                    placeholder=''
                    name='nombre'
                  />
                </div>
                <div className='p-field'>
                  <label htmlFor='numero'>
                    {t("cuadroCuentas.modal.numLabel")}
                  </label>

                  <FormikInputNumber
                    placeholder=''
                    name='numero'
                  />
                </div>
                <ButtonVuzoom
                  className='!tw-bg-primary'
                  type='submit'
                  onClick={handleSubmit}
                >
                  {editing
                    ? t("cuadroCuentas.modal.editButton")
                    : t("cuadroCuentas.modal.createButton")}
                </ButtonVuzoom>
              </form>
            )
          }}
        </Formik>
      )}
    </Modal>
  )
}

export default ModalCrearCuentaContable
